export default __webpack_public_path__ + "static/media/2.1123a95e.jpg";